import React from "react";
import { OperatorsPage } from "./OperatorsPage";

const Operators = () => {
	return <OperatorsPage />;
};

export default Operators;
